import {CustomParameterModel} from "../../../modules/custom-parameters/models/custom-parameter.model";

export class CustomParametersDetailsModel {
  id: number;
  value1: string; // Min
  value2: string; // Max
  tolerance: number;
  defaultValue: string;
  customParam: CustomParameterModel;
}
